// extracted by mini-css-extract-plugin
module.exports = {"DeleteIcon":"DeleteIcon_-gxeA"};